/**
 * bpmMetrics.js — cliente de las APIs de métricas BPM (/engine-users/metrics/*).
 * Todos los endpoints aceptan los mismos filtros opcionales:
 *   { fromdate, todate, officecode, flowid, taskid, actorid, limit }
 * Ver docs (xflow_backv2/docs/bpm-metrics.md).
 */
import ApiClient from "../api/ApiClient";
import EndPoint from "../api/Endpoints";

async function post(endpointKey, filters) {
  try {
    const resp = await ApiClient.doPost(EndPoint[endpointKey], filters || {});
    return resp || { status: false };
  } catch (err) {
    console.log(">>>> bpmMetrics", endpointKey, err);
    return { status: false, message: "ERR:" + err };
  }
}

export const getBpmOverview    = (f) => post("bpmOverview", f);
export const getBpmBacklog     = (f) => post("bpmBacklog", f);
export const getBpmFlowCycle   = (f) => post("bpmFlowCycle", f);
export const getBpmThroughput  = (f) => post("bpmThroughput", f);
export const getBpmBottlenecks = (f) => post("bpmBottlenecks", f);
export const getBpmWorkload    = (f) => post("bpmWorkload", f);
export const getBpmTransitions = (f) => post("bpmTransitions", f);
export const getBpmVariables   = (f) => post("bpmVariables", f);

/* ── helpers de formato ── */
export function minutesToHuman(min) {
  const m = Math.round(Number(min) || 0);
  if (m < 60) return m + " min";
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (h < 24) return h + "h" + (rem ? " " + rem + "m" : "");
  const d = Math.floor(h / 24);
  return d + "d " + (h % 24) + "h";
}

/* Rango de fechas por defecto (últimos N días) en formato 'YYYY-MM-DD HH:mm:ss' */
export function defaultRange(days = 30) {
  const pad = (n) => String(n).padStart(2, "0");
  const fmt = (d, end) =>
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
    (end ? "23:59:59" : "00:00:00");
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - days);
  return { fromdate: fmt(from, false), todate: fmt(to, true) };
}
